import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, MatTableDataSource } from "@angular/material";
import { FormControl } from "@angular/forms";
import { LoaderService } from "src/app/shared/loader/loader.service";
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
import { UserService } from "src/app/services/user/user.service";

@Component({
	selector: "app-permission-list",
	templateUrl: "./list.component.html",
	styleUrls: ["./list.component.scss"]
})
export class PermissionListComponent implements OnInit {
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	columns = ["email", "name", "userType"];
	dataSource = new MatTableDataSource();
	filter: FormControl = new FormControl("");
	length = 0;

	constructor(private loaderService: LoaderService, private userService: UserService) {}

	ngOnInit() {
		this.getData();
		this.createObservables();
	}

	createObservables() {
		this.filter.valueChanges
			.pipe(
				debounceTime(300),
				distinctUntilChanged(),
				tap(() => this.getData())
			)
			.subscribe();
		this.paginator.page.subscribe(() => this.loadData());
	}

	getData() {
		this.paginator.pageIndex = 0;
		this.loadData();
	}

	loadData() {
		const query = {
			filter: this.filter.value,
			page: this.paginator.pageIndex,
			limit: this.paginator.pageSize ? this.paginator.pageSize : 10
		};

		this.loaderService.newLoader("Buscando Permissões");

		this.userService.listPermissions(query).subscribe((response: any) => {
			this.loaderService.stopLoader();
			this.length = response.count;
			this.dataSource.data = response.users;
		});
	}
}
